const getGameType = (image) => {
  switch (image) {
    case 'PCSOEZ2LG':
      return '2D';
    case 'PSCOSTLMISOR':
      return 'STLMISOR';
    case 'PSCOSTLCDO':
      return 'STLCDO';
    case 'PSCOSTLBUKIDNON':
      return 'STLBUKIDNON';
    case 'PSCOS2':
      return 'S2';
    case 'PCSOLAST2':
      return 'LAST2';
    case 'PCSOLAST3':
      return 'LAST3';
    case 'PCSOPICK3LG':
      return 'PICK3';
    case 'PCSOSTL':
      return 'STL';
    case 'PSCO4D':
      return '4D';
    case 'PSCO6D':
      return '6D';
    default:
      return 'Swertres';
  }
};

export default getGameType;
